import { render, staticRenderFns } from "./Medal4.vue?vue&type=template&id=37cf42ac&"
import script from "./Medal4.vue?vue&type=script&lang=js&"
export * from "./Medal4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports